/**
 * batch-67 portal-thema (FO-504) - constanten van de themabanner in een module
 * ZONDER 'use client', zodat een server component ze als waarde kan
 * importeren (een export uit een client-module zou daar een client reference
 * zijn, zie de drift-guard client-module-value-import).
 */

/** Hoe lang de animatie loopt voordat de banner stilvalt (spec: 6 s). */
export const THEMA_BANNER_ANIMATIE_MS = 6000

/** Duur van één vallend deeltje (s); met de vertraging blijft alles binnen 6 s. */
export const THEMA_DEELTJE_VAL_S = 2.8
/** Duur van het twinkelen: 2 x 1,5 s (s). */
export const THEMA_DEELTJE_TWINKEL_S = 3

/**
 * Geen deeltje staat verder dan dit percentage naar rechts. Op 375 px begint
 * de wegklikknop op ongeveer 85 procent van de banner; een deeltje dat daar
 * achterlangs valt maakt het kruisje onduidelijk (gezien in de browsercontrole).
 */
export const THEMA_DEELTJE_MAX_LINKS = 82

/**
 * Vaste posities en vertragingen voor de deeltjes (geen Math.random: de
 * server en de browser moeten dezelfde markup geven). Links in procenten,
 * vertraging in seconden, grootte in pixels. De eerste twaalf zijn de gewone
 * themadag, de rest komt erbij op een hoogtepunt. Vertraging + duur blijft
 * onder de 6 s zodat niets halverwege wordt afgekapt.
 */
export const THEMA_DEELTJES: ReadonlyArray<
  readonly [links: number, vertraging: number, grootte: number]
> = [
  [5, 0, 5],
  [12, 1.1, 4],
  [19, 0.4, 6],
  [26, 1.6, 4],
  [33, 0.2, 5],
  [40, 1.3, 4],
  [47, 0.7, 6],
  [54, 1.9, 4],
  [61, 0.1, 5],
  [68, 1.4, 4],
  [75, 0.9, 5],
  [82, 0.5, 4],
  // Extra deeltjes voor het hoogtepunt.
  [9, 2.3, 4],
  [23, 2.6, 5],
  [37, 2.1, 4],
  [51, 2.8, 5],
  [65, 2.4, 4],
  [79, 3.0, 4],
]
